<template>
  <div class="footer">
    <div v-if="isLogin" class="foot-top">
      <div class="w1200">
        <dl class="foot-dl foot-dl1">
          <router-link :to="{name: 'Help'}">
            <dt class="c-white fs18 fs-rem20">客服中心</dt>
          </router-link>
          <!-- <dd>
            <a href="###" class="c-gray fs-rem18">友情链接</a>
          </dd>
          <dd>
            <a href="###" class="c-gray fs-rem18">友情链接</a>
          </dd> -->
        </dl>
        <dl class="foot-dl foot-dl2">
          <router-link :to="{name: 'About'}">
            <dt class="c-white fs18 fs-rem20">关于智慧云网</dt>
          </router-link>
          <!-- <dd>
            <a href="javascript:;" class="c-gray fs-rem18">友情链接</a>
          </dd>
          <dd>
            <a href="javascript:;" class="c-gray fs-rem18">友情链接</a>
          </dd> -->
        </dl>
        <dl class="foot-dl foot-dl3">
          <dt class="c-white fs18 fs-rem20 foot-news" @click="tolinknews">
            平台新闻
          </dt>
          <!-- <dd>
            <a href="###" class="c-gray fs-rem18">友情链接</a>
          </dd>
          <dd>
            <a href="###" class="c-gray fs-rem18">友情链接</a>
          </dd> -->
        </dl>
        <dl class="foot-dl foot-dl4">
          <router-link :to="{name: 'Contact'}">
            <dt class="c-white fs18 fs-rem20">联系我们</dt>
          </router-link>
          <!-- <dd>
            <a href="###" class="c-gray fs-rem18">友情链接</a>
          </dd>
          <dd>
            <a href="###" class="c-gray fs-rem18">友情链接</a>
          </dd>
          <dd>
            <a href="###" class="c-gray fs-rem18">友情链接</a>
          </dd> -->
        </dl>
        <div class="foot-othinfo">
          <div class="telbox c-white">
            <div class="fs-rem20 txt">客服热线</div>
            <div class="fs20 fs-rem24 bignum">186 0002 7596</div>
          </div>
          <!-- <select class="selbox">
            <option>中国站</option> -->
            <!-- <option>中国站2</option>
            <option>中国站3</option> -->
          <!-- </select> -->
        </div>
      </div>
    </div>
    <div class="foot-bot">
      <p class="fs-rem16 yi-tc c-white">Copyright 智慧城市云网 版权所有  <a style="color:#fff;padding-left:5px;" href="https://beian.miit.gov.cn" target="_black">京ICP备15036708号-2</a></p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    props: {
      msg: String,
      isLogin: Boolean
    },
    methods: {
      tolinknews() {
        window.location.href =
          'https://mp.weixin.qq.com/mp/homepage?__biz=MzAwNDUzMjYzMQ==&hid=2&sn=41c5ad06d1bfec7c74ff8f927456fd63&scene=18'
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import url(./Footer.css);

  .foot-news {
    cursor: pointer
  }
</style>
